/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

// pcg-core: shared thresholds and identity constants.
// Vendored from the PCG Exam Viewer prototype (core-viewer.js lines 6-9, 20-23, 49-54).
// The portal runs the CANONICAL exam-viewer math: in the prototype the demo server
// rebranded APP_NAME/APP_VERSION at serve time to enable the canonical branches;
// here canonical mode is hard-enabled (see MODULE-MAP.md) and these constants only
// stamp export payload provenance.

export const APP_NAME = "PCG Exam Viewer"
// Upstream extended every canonical allow-list with "0.8.1-dev.18" and later
// "0.8.1", "0.8.2", "0.8.3" (the lists themselves stay deleted here — canonical
// mode is hard-enabled); the identity stamp tracks the absorbed prototype
// version (handoff v0.8.3).
export const APP_VERSION = "0.8.3"
export const APP_BUILD_NOTE = "Medaica portal pcg-core vendored modules (canonical exam-viewer math, hard-enabled)."

export const MURMUR_GUIDE_THRESHOLD = 0.35
export const MURMUR_MIN_MEAN = 0.06
export const MURMUR_MIN_SUSTAINED_S = 0.004
export const TURBULENT_EDGE_TRIM_S = 1.0

export const MIN_USABLE_CYCLES = 5
export const MIN_ENERGY_RELIABLE_CYCLES = 8
export const MIN_ENERGY_HIGH_CONF = 0.75
export const MAX_ENERGY_LOW_CONF = 12
export const MAX_ENERGY_LOW_CONF_RATIO = 0.2
export const ENERGY_COVERAGE_DELTA = 0.3
